// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2oYPl","name":"ConsentHeader_name__2fyek","birthday":"ConsentHeader_birthday__8-8QQ","skeleton":"ConsentHeader_skeleton__gmW2f"};